import { UseFormSetError } from '@fiverr-private/forms';
import {
    useIdentificationContext,
    raiseErrorToast,
    services,
    submitCheckoutV2,
} from '@fiverr-private/identification_core';
import { useStepsContext } from '../../../StepsContext';
import { FormSchema } from '../EmailIdentificationStep.schema';
import { globalBigQueryReporter, globalGrafanaReporter } from '../../../../events';
import { translate } from '../../../../utils/translate';

export const PASSWORD_SERVER_ERROR = 'server_error';

export const useSubmitHandler = ({
    isSignUp,
    setError,
    setLoading,
}: {
    isSignUp: boolean;
    setError: UseFormSetError<FormSchema>;
    setLoading(value: boolean): void;
}) => {
    const { goToStep } = useStepsContext();
    const {
        setEmail,
        setMode,
        setPassword,
        finishSigningFlowAndNavigate,
        setRedirectUrl,
        inBeetlesMigrateSigninWebRollout,
    } = useIdentificationContext();

    const onSubmit = async (data: FormSchema) => {
        setLoading(true);

        if (isSignUp) {
            setEmail(data.usernameOrEmail);
            setPassword(data.password);
            setMode('sign_up');
            goToStep('profile_setup');
            return;
        }

        try {
            const {
                redirectUrl,
                guestCheckout,
                errorKeys = [],
            } = await services.signIn({
                login: data.usernameOrEmail,
                password: data.password,
                funnel: 'business',
                inBeetlesMigrateSigninWebRollout,
            });

            if (errorKeys.length) {
                const [errorKey] = errorKeys;

                setError('password', {
                    message: translate(`validation.password.${errorKey}`),
                    type: PASSWORD_SERVER_ERROR,
                });
                return;
            }

            if (submitCheckoutV2('login', guestCheckout)) {
                return;
            }

            setMode('sign_in');

            if (redirectUrl) {
                setRedirectUrl(redirectUrl);
            }

            globalGrafanaReporter.count('identification.%{platform}.signin.completed');
            await finishSigningFlowAndNavigate();
        } catch (err) {
            globalBigQueryReporter.send('identification.failed');
            globalGrafanaReporter.count('identification.%{platform}.signin.failed');
            raiseErrorToast();
        } finally {
            setLoading(false);
        }
    };

    return {
        onSubmit,
    };
};
